import { html } from "lit-html";
import { LampEasySearchAction } from "../../../actions/lamp/lamp_search_action";
import { each } from "../../../component";
import { LampEasySearchJsEnv, RefinementSearchElement } from "../../../models/lamp/lamp_js_env";

export const CandidateWordSearchArea = (model: LampEasySearchJsEnv) => {
  return html`
  <div class="m-modelsearch">
    <div class="m-modelsearch_option">
      <div class="m-modelsearch_hdg">
        <div class="a-heading -typep">
          <p class="a-heading_text"><label for="model-0" class="a-label">候補ワード</label></p>
        </div>
      </div>
      ${(model.hasRefinementSearchElements) ? SelectCandidateWordArea(model) : NoCandidateWordArea(model)}
    </div>
  </div>
  `;
}

const NoCandidateWordArea = (model: LampEasySearchJsEnv) => html`
<div class="m-modelsearch_words -small is-disabled">
  <div class="m-modelsearch_wordsinner js-scroll-bar"></div>
</div>
<div class="m-modelsearch">
</div>
${(model.inputWord === '') ? html`` : html`<div class="m-speech -error -bold">該当型番が見つかりません</div>`}
`;

const SelectCandidateWordArea = (model: LampEasySearchJsEnv) => html`
<div class="m-modelsearch_words -small" id="modelsearch_words">
  <div class="m-modelsearch_wordsinner js-scroll-bar">
    <ul class="js-model-search">
      ${each(CreateLampModels(model.refinementSearchElements, model.selectedModel), CandidateWord)}
    </ul>
  </div>
</div>
`;

const CandidateWord = (refinementSearchElement: LampModels, index: number) => html`
<li>
  <input type="radio" name="lamp"
    value="${refinementSearchElement.lampModel}" id="model-${index}"
    .checked=${refinementSearchElement.lampModel === refinementSearchElement.selectedModel}
    @change=${(event: Event) => { LampEasySearchAction.updateSelectedModel(getValueFromEvent(event)) }}
  />
  <label for="model-${index}">${refinementSearchElement.lampModel}</label>
</li>
`

const getValueFromEvent = (event: Event): string => {
  const { target } = event;

  if (!(target instanceof HTMLInputElement)) {
    throw 'cannot get value from event.';
  }

  return target.value;
}

const CreateLampModels = (refinementSearchElements: RefinementSearchElement[], selectedModel: string): LampModels[] => {
  return refinementSearchElements.map(refinementSearchElement => {
    let lampModel: LampModels = {
      lampModel: refinementSearchElement.refinementSearchDisplayName,
      selectedModel: selectedModel
    }
    return lampModel;
  })
}

interface LampModels {
  lampModel: string;
  selectedModel: string;
}
